import { Box } from "@mui/system";
import { Container } from "@mui/material";
import LoadingDots from "components/LoadingDots";
import main_white from "assets/static/logo/logo.png";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import "./index.modules.css";
import { get } from "utilities/requests";
import CustomSection from "components/CustomSection";

const PoliticaPrivacidadePage = () => {
  const [readyToRender, setReadyToRender] = useState(false);
  const [all_policy, setAll_policy] = useState({});

  const getto = async () => {
    const res = await get(`policy-and-terms`);
    setReadyToRender(true);
    setAll_policy(res);
  };

  useEffect(() => {
    getto().catch((e) => {
      console.log(e);
    });
  }, []);

  return (
    <CustomSection
      style={{
        overflow: "hidden",
        position: "relative",
        minHeight: "auto",
      }}
    >
      {readyToRender ? (
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1.8rem",
            margin: "auto",
            padding: "8rem 0",
            width: "100vw",
            animation: "show_section 1s",
          }}
        >
          <img
            src={main_white}
            alt="OnTest logotipo"
            style={{
              width: "20rem",
              margin: "10rem auto 6rem auto",
            }}
          />

          <div
            style={{
              margin: "6rem 0",
              gap: "4rem",
              // display: "flex",
              flexDirection: "column",
              lineHeight:2

            }}
          >
            <h1 style={{textAlign:'center'}}>POLÍTICA DE PRIVACIDADE</h1>

            <p class="p8">A <strong>ENTERSCIENCE</strong> valoriza a privacidade de seus usuários, clientes, fornecedores e colaboradores, e por isso, criou essa Política de Privacidade, para demonstrar seu compromisso com a proteção de dados pessoais, nos termos da LGPD (Lei 13.709/2018, a Lei Geral de Proteção de Dados), durante o processo de interação com nosso site e aplicativos. Para deixar claro quais informações coletamos e como as utilizamos, armazenamos e excluímos, detalhados a seguir em nossa Política de Privacidade.</p>
<p class="p9"><strong>1.<span class="Apple-tab-span">	</span>INFORMAÇÕES GERAIS E DEFINIÇÕES</strong></p>
<p class="p5"><br/></p>
<p class="p8"><strong>Usuário:</strong> são todas as pessoas físicas que acessam os nossos serviços, maiores de 18 (dezoito) anos ou emancipadas e totalmente capazes de praticar os atos da vida civil, ou os absolutamente ou relativamente incapazes devidamente representados ou assistidos.</p>
<p class="p8"><strong>Dados Pessoais: </strong>são quaisquer informações fornecidas e/ou coletadas pela ENTERSCIENCE , por qualquer meio, ainda que públicos, que: (I) identifiquem, ou que, quando usadas em combinação com outras informações tratadas pela ENTERSCIENCE identifique um indivíduo; ou (II) por meio das quais a identificação ou informações de contato de uma pessoa física possam ser derivadas.<span class="Apple-converted-space">&nbsp;</span></p>
<p class="p8"><strong>Finalidade: </strong>é o objetivo, o propósito que a <strong>ENTERSCIENCE</strong> deseja alcançar, a partir de cada ato de tratamento das informações pessoais.</p>
<p class="p8"><strong>Necessidade:</strong> é a justificativa pela qual é estritamente necessário coletar dados pessoais, para atingir a finalidade, evitando-se a coleta excessiva.</p>
<p class="p8"><strong>Bases legais: </strong>fundamentação legal que torna legítimo o tratamento de dados pessoais para uma determinada finalidade prévia por parte da <strong>ENTERSCIENCE</strong>.</p>
<p class="p8"><strong>Consentimento:</strong> autorização expressa e inequívoca dada pelo Usuário titular do dados pessoais para que a ENTERSCIENCE trate os dados pessoais para uma finalidade previamente descrita, na qual, a base legal necessária para o ato demande a autorização expressa do titular.<span class="Apple-converted-space">&nbsp;</span></p>
<p class="p10"><br/></p>
<p class="p11"><strong>2.<span class="Apple-tab-span">	</span>A QUEM SE APLICA ESSA POLÍTICA DE PRIVACIDADE</strong><span class="s1"><strong><span class="Apple-converted-space">&nbsp;</span></strong></span></p>
<p class="p8">Essa política de privacidade se aplica a todos os visitantes do site da ENTERSCIENCE que tenham os dados pessoais tratados por nós.<span class="Apple-converted-space">&nbsp;</span></p>
<p class="p10"><br/></p>
<p class="p11"><strong>3.<span class="Apple-tab-span">	</span>QUE TIPO DE INFORMAÇÕES PESSOAIS COLETAMOS</strong></p>
<p class="p8"><strong><br/>
</strong>Nós coletamos o mínimo possível de dados pessoais para chegar aos nossos objetivos e apenas utilizamos estes dados para as finalidades para as quais foram coletados.</p>
<p class="p8"><strong>3.1. Informações que você nos fornece no website: </strong>Nome, e-mail e telefone (whatsapp web).<span class="Apple-converted-space">&nbsp;</span></p>
<p class="p12"><strong>Finalidade:</strong> Tais informações não são transmitidas a terceiros e são de uso exclusivo da ENTERSCIENCE para fins de contatos comerciais, atendimento a pedidos, ouvidoria e reclamações. A ENTERSCIENCE também não vende, repassa ou compartilha seus dados pessoais coletados através do website.<br/>
<strong>Base Legal -<span class="Apple-converted-space">&nbsp; </span>Consentimento:</strong> Estou de acordo em fornecer meu dados, para receber contatos da área comercial, envio de comunicados e atendimento a pedidos e reclamações.</p>
<p class="p13"><br/></p>
<p class="p14"><strong>3.2. Informações coletadas automaticamente</strong></p>
<p class="p15">Além das informações fornecidas por você através de formulários de contato, também coletamos algumas informações automaticamente:</p>
<ul class="ul1">
<li class="li6"><span class="s3"><strong>Informações de u<span id="jodit-selection_marker_1761072506861_41599029147567157" data-jodit-temp="true" data-jodit-selection_marker="start" style={{lineHheight: 0,display: "none"}}>&#xFEFF;</span>so:</strong> coletamos informações sobre o uso, como cliques, e páginas visitadas. As informações coletadas são importantes tanto para melhorias do site quanto para mapeamento de possíveis erros.</span></li>
<li class="li6"><span class="s3"><strong>Informações de localização:</strong> coletamos informações sobre sua localização aproximada através do endereço IP do seu dispositivo. Esses dados são utilizados para análise de quantas pessoas acessam nosso site por região.</span></li>
<li class="li16"><span class="s3"><strong>Informações técnicas:</strong> coletamos informações como o tipo de navegador que você está utilizando, endereço IP, tipo de dispositivo, sistema operacional e informações de rede móvel. Coletamos essas informações para que possamos analisar e identificar problemas de incompatibilidades ou erros, com o objetivo de oferecer uma melhor experiência de navegação.</span></li>
</ul>
<p class="p14"><strong>3.3. Como utilizamos suas informações</strong></p>
<p class="p15">Sem desconsiderar as formas de uso de dados já expostas acima, a utilização dessas informações se dá, primordialmente, da seguinte forma:</p>
<ul class="ul1">
<li class="li6"><span class="s3">Utilizamos dados sobre o uso do site, com o objetivo de detectar comportamentos fora do padrão, monitorar e proteger nossos serviços;</span></li>
<li class="li16"><span class="s3">Utilizamos informações cadastradas por você em nossos formulários, para entrar em contato.</span></li>
</ul>
<p class="p11"><strong>4.<span class="Apple-tab-span">	</span>COM QUEM COMPARTILHAMOS SEUS DADOS</strong></p>
<p class="p8">As informações coletadas no website não serão compartilhadas.<br/>
Não coletamos intencionalmente dados pessoais de crianças e adolescentes. Ao tomarmos conhecimento de que usuários neste perfil nos enviaram dados pessoais, esses dados serão excluídos o mais breve possível. Caso você seja menor de 18 anos, você poderá usar os serviços da ENTERSCIENCE somente com o acompanhamento de seus pais ou responsáveis legais. Em caso de dúvidas, entre em contato conosco através do e-mail contato@enterscience.com.br.</p>
<p class="p10"><br/></p>
<table cellspacing="0" cellpadding="0" class="t1">
<tbody>
<tr>
<td valign="top" class="td1">
<p class="p17">Ao acessar ou utilizar o site da ENTERSCIENCE, o Usuário declara ter no mínimo 18 (dezoito) anos e ter capacidade plena e expressa para a aceitação dos termos e condições desta Política de Privacidade para todos os fins de direito.<span class="Apple-converted-space">&nbsp;</span></p>
<p class="p17">Caso o Usuário não se enquadre na descrição acima ou não concorde, ainda que em parte, com os termos e condições contidos nesta Política de Privacidade, não deverá acessar ou utilizar quaisquer serviços oferecidos pela ENTERSCIENCE.</p>
</td>
</tr>
</tbody>
</table>
<p class="p10"><br/></p>
<p class="p18"><strong>5.<span class="Apple-tab-span">	</span>POR QUANTO TEMPO GUARDAMOS ESSES DADOS?</strong></p>
<p class="p8">A ENTERSCIENCE apenas guardará os seus dados pelo tempo necessário para o cumprimento das finalidades para os quais eles foram coletados, inclusive para fins de cumprimento de obrigações legais, contratuais, prestação de contas ou eventual requisição de autoridades competentes.<span class="Apple-converted-space">&nbsp;</span></p>
<p class="p10"><br/></p>
<p class="p11"><strong>6.<span class="Apple-tab-span">	</span>DADOS COLETADOS/TRATADOS POR TERCEIROS</strong></p>
<p class="p8">Nós utilizamos serviços de serviços de terceiros para hospedar nosso site e nosso e-mail e também para entender quais são as suas demandas por conteúdo e serviços. Para isso, às vezes é necessário compartilhar seus dados com estes terceiros. Mas só compartilhamos o estritamente necessário, de acordo com os parâmetros e garantias estipulados nesta Política.</p>
<p class="p10"><br/></p>
<p class="p11"><strong>7.<span class="Apple-tab-span">	</span>COOKIES</strong></p>
<p class="p8">Podemos definir “cookie” como um conjunto de informações que um site pode armazenar no seu dispositivo até que perca sua validade. A partir do momento que essas informações forem armazenadas, elas serão fornecidas pelo seu navegador sempre que você acessar esse site, fazendo com que suas preferências sejam aplicadas. Nós utilizamos cookies para armazenar dados com o objetivo de saber se o usuário já acessou anteriormente nossos sites e, dessa forma, para que tenha uma melhor experiência com nossos serviços, poderemos direcionar conteúdos relevantes.</p>
<p class="p8"><strong>Nós utilizamos cookies.</strong> Você pode ajustar suas configurações de navegador para desabilitar os cookies ou deletá-los. Caso estejam habilitados, nós (e os terceiros previamente mencionados) emitiremos cookies quando você interagir com o nosso site.</p>
<p class="p8">Somente coletamos, via cookies, dados essenciais para o funcionamento do nosso site e para medir métricas de acesso. Não compartilhamos estes dados com terceiros, além daqueles responsáveis pelos próprios cookies.</p>
<p class="p10"><br/></p>
<p class="p11"><strong>8.<span class="Apple-tab-span">	</span>EXCLUSÃO DE DADOS PESSOAIS</strong></p>
<p class="p8">Todos os dados coletados serão excluídos de nossos servidores quando você assim requisitar, por procedimento gratuito e facilitado, ou quando estes não forem mais necessários ou relevantes para lhe oferecermos os nossos serviços, salvo se houver qualquer outra razão para a sua manutenção, como eventual obrigação legal de retenção de dados ou necessidade de preservação destes para resguardo de direitos da ENTERSCIENCE.<span class="Apple-converted-space">&nbsp;</span></p>
<p class="p8">Você também poderá solicitar a remoção de seus dados diretamente através do e-mail contato@enterscience.com.br.</p>
<p class="p10"><br/></p>
<p class="p11"><strong>9.<span class="Apple-tab-span">	</span>REDES SOCIAIS</strong></p>
<p class="p8">A ENTERSCIENCE utiliza redes sociais para divulgação e comunicação das nossas atividades. Especificamente, usamos Instagram, Linkedin, Twitter, Youtube e Facebook.</p>
<p class="p10"><br/></p>
<p class="p11"><strong>10.<span class="Apple-tab-span">	</span>ALTERAÇÕES</strong></p>
<p class="p8">A ENTERSCIENCE pode alterar essa Política a qualquer momento, por isso é muito importante acessá-la periodicamente. Para facilitar, indicamos no início do documento a data da última atualização. Caso sejam feitas alterações relevantes que ensejem a necessidade de novas autorizações, nós o informaremos previamente, a fim de garantir o consentimento.</p>
<p class="p10"><br/></p>
<p class="p19">Seja bem vindo!</p>
<p class="p19"><strong>DPO da ENTERSCIENCE</strong></p>
<p class="p19"><strong>contato@enterscience.com.br</strong></p>


            {/* {all_policy["policy"].map((policy, index) => {
              const [title, text] = policy.content.split("_{slice}_");
              return (
                <div key={index} className="text-row">
                  <h2>{title}</h2>
                  <Typography
                    variant="p"
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                  />
                </div>
              );
            })} */}

            {/* caso não exista texto para mostrar, uma outra mensagem será mostrada: */}
            {/* {all_policy["policy"].length === 0 ? (
              <>
                <p
                  style={{
                    fontSize: "2rem",
                    color: "var(--purple)",
                    textAlign: "center",
                    margin: "6rem 0",
                    fontFamily: "var(--Raleway)",
                  }}
                >
                  Não há política de privacidade.
                </p>
              </>
            ) : (
              ""
            )} */}
          </div>
        </Container>
      ) : (
        <div
          style={{
            backgroundColor: "rgb(240, 244, 247)",
            minWidth: "100vw",
            minHeight: "100vh",
          }}
        >
          <LoadingDots />
        </div>
      )}
    </CustomSection>
  );
};

export default PoliticaPrivacidadePage;
